(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('InitValueDialogController', InitValueDialogController);

    InitValueDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'InitValue'];

    function InitValueDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, InitValue) {
        var vm = this;

        vm.initValue = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.initValue.id !== null) {
                InitValue.update(vm.initValue, onSaveSuccess, onSaveError);
            } else {
                InitValue.save(vm.initValue, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:initValueUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();
